<template>
  <aside class="connection-diagnostics" :class="{ expanded }">
    <button class="diagnostics-toggle" type="button" @click="expanded = !expanded">
      {{ expanded ? '收起连接诊断' : '连接诊断' }}
    </button>
    <div v-if="expanded" class="diagnostics-body">
      <dl>
        <template v-for="item in rows">
          <dt :key="`${item.key}-label`">{{ item.label }}</dt>
          <dd :key="item.key">{{ item.value }}</dd>
        </template>
      </dl>
      <form class="manual-device-form" @submit.prevent="submitManual">
        <strong>手动连接回退</strong>
        <input v-model.trim="manual.host" aria-label="Rock5A IP" placeholder="例如 192.168.1.100" />
        <div class="manual-ports">
          <input v-model.number="manual.controlPort" aria-label="控制端口" type="number" min="1" max="65535" />
          <input v-model.number="manual.audioPort" aria-label="音频端口" type="number" min="1" max="65535" />
        </div>
        <label><input v-model="manual.secure" type="checkbox" /> 使用 WSS</label>
        <button type="submit" :disabled="manualBusy">{{ manualBusy ? '检测中…' : '检测并连接' }}</button>
        <button type="button" @click="$emit('retry-discovery')">重试本机发现</button>
      </form>
    </div>
  </aside>
</template>

<script>
export default {
  name: 'ConnectionDiagnostics',
  props: {
    diagnostics: { type: Object, required: true },
    manualBusy: { type: Boolean, default: false },
  },
  data: () => ({
    expanded: false,
    manual: { host: '', controlPort: 8770, audioPort: 8771, secure: false },
  }),
  computed: {
    rows() {
      const d = this.diagnostics
      return [
        ['page', '页面', `${d.pageUrl} (${d.pageProtocol})`],
        ['device', 'Rock5A', d.device || '未选择'],
        ['source', '发现方式', d.discoverySource || '未选择'],
        ['helper', '发现助手', d.helperHealth],
        ['control', '控制 8770', d.control],
        ['audio', '音频 8771', d.audio],
        ['assistant', 'Assistant', d.assistant],
        ['assistantUrl', 'Assistant URL', d.assistantUrl || '未配置'],
        ['role', 'clientRole', d.clientRole],
        ['session', 'sessionId', d.sessionId || '未建立'],
        ['build', '前端构建', d.buildInfo],
        ['runtime', 'Runtime', d.runtimeEnabled ? 'enabled' : 'disabled'],
        ['token', '设备会话 Token', d.tokenState],
        ['demo', '洪水模式', d.demoFloodMode ? 'DEMO' : '正式适配器'],
        ['blocked', '浏览器拦截', d.browserBlocked ? '是' : '否'],
        ['close', 'WS 关闭码', d.closeCode || '无'],
        ['error', '最后错误', d.lastError || '无'],
      ].map(([key, label, value]) => ({ key, label, value }))
    },
  },
  methods: {
    submitManual() { this.$emit('manual-connect', { ...this.manual }) },
  },
}
</script>

<style scoped>
.connection-diagnostics {
  position: relative;
  width: fit-content;
  max-width: 100%;
  color: #d9f7ff;
  font-size: 12px;
}
.connection-diagnostics.expanded { width: min(400px, 100%); }
.diagnostics-toggle, .manual-device-form button { border: 1px solid #2d8ea3; border-radius: 6px; color: #d9f7ff; background: rgba(6, 25, 36, .94); padding: 5px 9px; font-size: 11px; line-height: 18px; }
.diagnostics-toggle { display: inline-flex; align-items: center; min-height: 30px; cursor: pointer; white-space: nowrap; }
.diagnostics-body { margin-top: 6px; max-height: min(58vh, 520px); overflow: auto; border: 1px solid rgba(45, 142, 163, .6); border-radius: 6px; background: rgba(6, 18, 28, .96); padding: 10px; }
dl { display: grid; grid-template-columns: 120px 1fr; gap: 4px 8px; margin: 0 0 10px; }
dt { color: #75bed0; } dd { margin: 0; overflow-wrap: anywhere; }
.manual-device-form { display: grid; gap: 7px; border-top: 1px solid #244b57; padding-top: 10px; }
.manual-device-form input { min-width: 0; border: 1px solid #315965; border-radius: 4px; background: #07151d; color: #fff; padding: 6px; }
.manual-ports { display: grid; grid-template-columns: 1fr 1fr; gap: 6px; }
</style>
